import { UnifiedBallotStatus } from "../../../../../shared/enums/unified-ballot-status-enum";
import { IBallotHistoryItem } from "../ballot-base/ballot-history-item";
import { SrsBallotReviewStage } from "./srs-ballot-review-stage";
import { ISrsBallotVote } from "./srs-vote";


export interface ISrsBallotDetail {
  ballotId: string;
  simPublicationId: string;
  designationTitle: string;
  designation: string;
  designationURL: string;
  isJoint: boolean;
  publicationCreateDate?: Date;
  committee: string;
  committeeTitle: string;
  projectManager: string;
  projectManagerEmail: string;
  associatedDocuments: IAssociatedDocument[];
  ballotStartDate?: Date;
  ballotEndDate?: Date;
  createDate?: Date;
  statusId: string;
  //ballotStatus: string;
  status: string;
  ballotResolution: string;
  finalComment: string;
  votes: ISrsBallotVote[];
  hasStatusDoc: boolean;
  statusDoc: string;
  isBallotAutoCreated: boolean;
  assignedTo: string;
  srtComment: string;
  hoSDComment: string;
  hoSDApproval: string;
  srtApproval: string;
  revisitDate?: Date;
  reviewStageId?: SrsBallotReviewStage;
  reviewStageDisplayText?: string
  notes: string;
  unifiedStatusId: UnifiedBallotStatus;
  ballotHistory: IBallotHistoryItem[];
}

export interface IAssociatedDocument {
  datedDesignation: string;
  designationTitle: string;
  uri: string;
  relationshipType: string;
}

export enum SrsBallotStatusId {
  PSB_CREATED = "PSB_CREATED",
  PSB_PENDING_CLOSURE = "PSB_PENDING_CLOSURE",
  PSB_DEFERRED = "PSB_DEFERRED",
  PSB_ON_HOLD = "PSB_ON_HOLD",
  PSB_SCHEDULED = "PSB_SCHEDULED",
  PSB_OPENED = "PSB_OPENED",
  PSB_DECISION_PENDING = "PSB_DECISION_PENDING",
  PSB_REVIEW_COMPLETE = "PSB_REVIEW_COMPLETE",
  PSB_PENDING_FINALISED_APPROVAL = "PSB_PENDING_FINALISED_APPROVAL"
}
